const $ = require('jquery');

export function messageBar() {

    const prefix = $('#header-message-bar').data('prefix');
    const reappear = $('#header-message-bar').data('reappear');

    const myCookie = $.cookie('hide-message-bar-'+prefix);
    if (myCookie) { 
        $('#header-message-bar').css({'display':'none'});	
    } else {
        $('#header-message-bar').css({'display':'block'});
    }

    $( "#header-message-bar .close" ).click(function() {
        $('#header-message-bar').addClass('hide');
        $.cookie('hide-message-bar-'+prefix, '1', { expires: reappear });
    });

}